import { GridCellProps } from '@progress/kendo-react-grid';

export const UpperCaseStringCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  if (props.field) {
    let val = dataItem[props.field];
    if (val) {
      return <td>{val.toUpperCase()}</td>;
    }
  }

  return <td></td>;
};
